import { iEnquiry } from "../../interfaces/iEnquiry";

export function orderIdsByGrid(data: iEnquiry[], selectedItems: string[]): number[] {
    const selected = new Set(selectedItems);
    return data.filter(x => selected.has(x.id.toString())).map(x => x.id);
}

export function resolveEnquiriesInOrder(cache: iEnquiry[], ids: number[]): iEnquiry[] {
    const byId = new Map(cache.map(x => [x.id, x]));
    return ids.map(id => byId.get(id)).filter((x): x is iEnquiry => x !== undefined);
}

// Every enquiry grid displays its rows in the order of the session's active list (the views derive
// their data from it and each re-sort saves it), so this puts ids in grid display order for callers
// that cannot see the grid's data. Ids not in the list keep their order at the end, so the id set is unchanged.
export function orderIdsByActiveList(activeList: number[] | null, ids: number[]): number[] {
    const wanted = new Set(ids);
    const listed = (activeList ?? []).filter(id => wanted.has(id));
    const listedSet = new Set(listed);
    return [...listed, ...ids.filter(id => !listedSet.has(id))];
}
